<template>
    <div class="col-md-12 p-0 k-grid-toolbar">
        <kendo-toolbar id="toolbar" 
        @click="onClick"  @toggle="onToggle"
        :items="getToolBarItems">
        <!-- <kendo-toolbar-item :template="itemTemplate"></kendo-toolbar-item> -->
        </kendo-toolbar>
    </div> 
</template>

<script>
// DisableBaseDefaultItems:[
//         {name: "Refresh"},
//         {name:"Export",child:{name:"ExportSelected"}}
//     ]
export default {
  name: "BaseToolBarDemo",
  props: { config: { default: false } },
  computed: {
    getToolBarItems() {
      var ToolBarItems = this.LeftToolBarButtons;
      if (this.config) {
        //Disable Base Defaults based on Passed Config
        if (this.config.DisableBaseDefaultItems) {
          this.config.DisableBaseDefaultItems.forEach(obj=>{
            let index = ToolBarItems.findIndex(p => p.name == obj.name)
            if (index>=0) {
              if(obj.child){
                //Remove the Child Element
                  let childMenu=ToolBarItems[index].menuButtons;
                  let childIndex = childMenu.findIndex(p => p.name == obj.child.name)
                  childIndex>=0 ?childMenu.splice(childIndex,1) : ""
              }else{
                //remove the entire object
                  ToolBarItems.splice(index,1)
              }
            }
          })
        }
        this.config.items.forEach(element => {
          ToolBarItems.push(element);
        });
      }
      return ToolBarItems;
    }
  },
  data() {
    return {
      items: this.config.items,
      LeftToolBarButtons: [
        {
          id: "btnRefresh",
          name:"Refresh",
          type: "button",
          // text: "Export",
          icon: "reload",
          showIcon: "toolbar",          
          attributes: { "class": "relPosition1","title": "Refresh Data" }
        },
				{
          id: "btnGrouping",
          name:"Grouping",
          type: "splitButton",
          // text: "Export",
          icon: "rows",
					showIcon: "toolbar",
					menuButtons: [
            { id: "optExpandAll", name:"ExpandAll", icon: "more-vertical", text: "Expand All" },
            { id: "optCollapseAll",name:"CollapseAll", icon: "more-horizontal", text: "Collapse All" }
          ],
          attributes: { "class": "relPosition1", "title": "Toggle Grouping" }
        },
        {
          id: "btnExport",
          name:"Export",
          type: "splitButton",
          // text: "Export",
          icon: "file-excel",
          showIcon: "toolbar",
          menuButtons: [
            { id: "optExportAll", name:"ExportAll", icon: "table", text: "Export All Rows" },
            { id: "optExportSelected",name:"ExportSelected", icon: "row-freeze", text: "Export Selected Rows" }
          ],
          attributes: { "class": "relPosition1" ,"title": "Export to Excel"}
        },
        {
          id: "btnSaveViews",
          name:"SaveViews",
          //   icon: "plus-circle",
          type: "splitButton",
          // text: "Grid Settings",
					icon: "gear",
					showIcon: "toolbar",
          menuButtons: [
            { id: "optSaveSettings", icon: "save", text: "Save Settings"  },
            { id: "optResetSettings", icon: "reset", text: "Reset Settings" }
          ],
          attributes: { "class": "relPosition1", "title": "Grid Settings" }
        },
        {
          type:'separator'
        }
      ]
    };
  },
  methods: {
    // itemTemplate: function(e) {
    //   return {
    //     template: Vue.component(Template.name, Template),
    //     templateArgs: Object.assign({}, e, {
    //       parentComponent: this.$refs.ddl
    //     })
    //   };
    // },
    onClick(e) {
      //console.log(e);
      //console.log(e.id);
      this.$emit("buttonClicked", e);
    },
    onToggle(e){
      this.$emit("toggleButtonClicked", e);
    }
  },
  mounted() {
    let self =this;
     $( ".radioButton" ).on( "click", function( event ) {
        //console.log( event );
       // self.ViewPartnerGrid(event.target.id)
       self.$emit("buttonClicked", event.target);
    });
    $( ".checkBox" ).on( "click", function( event ) {
        //console.log( event );
       // self.ViewPartnerGrid(event.target.id)
       self.$emit("buttonClicked", event.target);
    });
  },
  components: {
  }
};
</script>
<style>
#toolbar{
  display: block !important;
}         
/* #btnExport_wrapper{
  margin-left: 20px;
}
#btnSaveViews_wrapper{
  margin-left: 30px;
}
.k-toolbar .k-separator{
  margin-left: 100px !important;
  border-width: 0 0 0 0 !important;
}
label {
    margin-bottom: 0 !important;
}
.k-toolbar{
  padding: 4px 4px;
}*/
</style>


